import { Link } from 'react-router'

export function Wordmark({ className = '' }) {
  return (
    <span className={`font-extrabold tracking-[-0.3px] text-ink ${className}`}>
      Urban<span className="text-teal">Purr</span>
    </span>
  )
}

export default function Logo() {
  return (
    <Link to="/" className="flex items-center gap-2.5 no-underline" aria-label="UrbanPurr">
      <img src="/brand/urbanpurr-mark.svg" alt="" className="h-10 w-12" />
      <Wordmark className="text-[26px]" />
    </Link>
  )
}
